import * as React from 'react'
import './styles.scss'

interface Props extends React.ComponentPropsWithoutRef<'input'> {
  variant: 'standard' | 'blue' | 'gray'
  format: 'square' | 'round'
}

export const CheckBox = ({ variant, format, ...rest }: Props) => {
  return (
    <div
      className={`checkbox-zero-height checkbox-variant-${variant} checkbox-format-${format}`}
    >
      <input type="checkbox" {...rest} />
    </div>
  )
}
